
import { defineComponent } from 'vue'
import Card from 'primevue/card'
import RadioButton from 'primevue/radiobutton'
import KpiDocumentDesignerTypeCardDescriptor from './KpiDocumentDesignerTypeCardDescriptor.json'

export default defineComponent({
    name: 'kpi-document-designer-type-card',
    components: { Card, RadioButton },
    props: { chartType: { type: String } },
    emits: ['typeChanged'],
    data() {
        return {
            KpiDocumentDesignerTypeCardDescriptor,
            type: 'kpi' as string
        }
    },
    watch: {
        chartType() {
            this.loadType()
        }
    },
    created() {
        this.loadType()
    },
    methods: {
        loadType() {
            this.type = this.chartType as string
        },
        onTypeChange() {
            this.$emit('typeChanged', this.type)
        }
    }
})
